module.exports = __webpack_public_path__ + "static/img/pic_02@2x.399c15d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_02@2x.png
// module id = oiWb
// module chunks = 2